import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFrownOpen } from '@fortawesome/pro-solid-svg-icons';
import { FORM_NAME, STREAM_ERROR } from './fields';
import { useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';

export const StreamError = () => {
  const { t } = useTranslation();
  const { [STREAM_ERROR]: error } = useSelector(getFormValues(FORM_NAME));

  if (!error) {
    return null;
  }

  let errorMessage = '';

  switch (error.kind) {
    case window.VideoCaptureAPI.PERMISSION_DENIED:
      errorMessage = t('mediastream_device_permission_denied');
      break;
    case window.VideoCaptureAPI.DEVICE_ALREADY_IN_USE:
      errorMessage = t('mediastream_device_in_use');
      break;
    case window.VideoCaptureAPI.DEVICE_NOT_FOUND:
      errorMessage = t('mediastream_device_not_found');
      break;
    default:
      errorMessage = t('mediastream_unknown');
  }

  return (
    <div className="text-center">
      <FontAwesomeIcon className="ct-mediastream-error-icon" icon={faFrownOpen} />
      <div className="ct-mediastream-error-text">{errorMessage}</div>
    </div>
  );
};
